export const privacyPolicy = [
  "This privacy notice discloses the privacy practices for iskconvvnagar.com. This privacy notice applies solely to information collected by this website. It will notify you of the following:",

  "1.What personally identifiable information is collected from you through the website, how it is used and with whom it may be shared.",
  "2.What choices are available to you regarding the use of your data.",
  "3.The security procedures in place to protect the misuse of your information.",
  "4.How you can correct any inaccuracies in the information.",

  "Information Collection, Use, and Sharing:-",

  "We are the sole owners of the information collected on this site. We only have access to collect information that you voluntarily give us via email or other direct contact from you.",
  "We will not sell or rent this information to anyone.",

  "We will use your information to respond to you, regarding the reason you contacted us. We will not share your information with any third party outside of our organization, other than as necessary to fulfil your request, e.g. to ship an order.",

  "Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy.",

  "Your Access to and Control Over Information:-",

  "You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number given on our website:",

  "1.See what data we have about you, if any.",
  "2.Change/correct any data we have about you.",
  "3.Have us delete any data we have about you.",
  "4.Express any concern you have about our use of your data.",

  "Security:-",

  "We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.",

  "We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.",

  "While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computer servers in which we store personally identifiable information are kept in a highly secure environment.",

  "If you feel that we are not abiding by this privacy policy, you should contact our business head immediately via telephone at 9998407654 or via email at iskconinfovvn@gmail.com",
];
